import React from 'react';
import { NuvoImporter, RejectSubmitResult } from 'nuvo-react';
import _ from 'lodash';
import '../styles.css';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useQuery, gql } from '@apollo/client';
import { portOfDataQry } from '../gql/PortOfDataQuery';
import { incoTermDataQry } from '../gql/incoTermDataQuery';
import { qualityGroupsDataQry } from '../gql/qualityGroupsDataQuery';
import { CurrenciesQry } from '../gql/CurrenciesQry';
import { ShippingLinesQry } from '../gql/ShippingLinesQry';
import { useMutation, useApolloClient } from '@apollo/client';
import { CREATE_ALL_IN_TRANSPORTS } from '../graphqlDefs/allTransports/mutations';
import { getTransportAllRateImporterSetting } from '../component/utils/transport_All_In_Rate';
import { volumeUnit } from './utils/volumeUnit';
import { QuantityUnitQry, PrecarriageQry } from '../gql/QuantityUnitQry';
import { getMessage } from '../translations';
import { GET_LOGISTIC_FORWARDER } from '../graphqlDefs/freights/mutations';

const TransportAllRateApp = () => {
  const client = useApolloClient();
  const navigate = useNavigate();
  const licenseKey = process.env.REACT_APP_LICENSE_KEY;
  const handleGoBack = () => {
    navigate(-1); // Navigates back one step
  };
  const handleNavigateWeb = () => {
    window.open(
      `${process.env.REACT_APP_TRANSPORT_ALL_IN_RATE_WEB_URL}`,
      '_blank'
    );
  };
  const [result, setResult] = useState('');
  // State to define for fetching portOfLoading names from database
  const [portLoadingDropdownData, setPortLoadingDropdownData] = useState();
  const [portDestinationDropdownData, setPortDestinationDropdownData] =
    useState();
  const [placeDeliveriesDropdownData, setPlaceDeliveriesDropdownData] =
    useState();
  const [incoTermDropdownData, setIncoTermDropdownData] = useState();
  const [qualityGroupDropdownData, setQualityGroupDropdownData] = useState();
  const [shippingLinesDropdownData, setshippingLinesDropdownData] = useState();
  const [currenciesDropdownData, setCurrenciesDropdownData] = useState();
  const [currenciesAbbrDropdownData, setCurrenciesAbbrDropdownData] =
    useState();
  const [volumeUnitDropdownData, setVolumeUnitDropdownData] = useState();
  const [preCarriageAreaDropdownData, setPreCarriageAreaDropdownData] =
    useState();

  // Graphql query fetch port of loading & destination data
  const { data } = useQuery(portOfDataQry);
  const incoTermData = useQuery(incoTermDataQry);
  const qualityGroupData = useQuery(qualityGroupsDataQry);
  const currenciesData = useQuery(CurrenciesQry);
  const shippingLineData = useQuery(ShippingLinesQry);
  const quantityUnitData = useQuery(QuantityUnitQry);
  const preCarriageAreaData = useQuery(PrecarriageQry);
  const filteredProvidersVariables = {
    filters: { type: 'SHIPPING_LINE' },
    searchText: null,
  };
  const {
    loading: loading1,
    error: error1,
    data: data1,
    refetch: refetch1,
  } = useQuery(GET_LOGISTIC_FORWARDER, {
    variables: { input: filteredProvidersVariables },
  });

  const fetchData = () => {
    const portOfLoadingNames =
      data && data?.portOfLoadings
        ? data?.portOfLoadings?.map((portOfLoading) => ({
          label: portOfLoading?.value,
          alternativeMatches: [portOfLoading?.value],
          value: portOfLoading?.value,
          type: 'string',
        }))
        : '>>';

    const portOfDestinationNames =
      data && data?.portOfDestinations
        ? data?.portOfDestinations?.map((portOfDestination) => ({
          label: portOfDestination?.value,
          alternativeMatches: [portOfDestination?.value],
          value: portOfDestination?.value,
          type: 'string',
        }))
        : '>>';

    const placeOfDeliveryNames =
      data && data?.placesOfDelivery
        ? data?.placesOfDelivery?.map((placesOfDelvry) => ({
          label: placesOfDelvry?.value,
          alternativeMatches: [placesOfDelvry?.value],
          value: placesOfDelvry?.value,
          type: 'string',
        }))
        : '>>';

    const intoTermsNames =
      incoTermData.data && incoTermData.data?.incoterms
        ? incoTermData.data?.incoterms?.map((incoT) => ({
          label: incoT?.value,
          alternativeMatches: [incoT?.value],
          value: incoT?.value,
          type: 'string',
        }))
        : '>>';

    const qualityGroupNames =
      qualityGroupData.data && qualityGroupData.data?.qualityGroups
        ? qualityGroupData.data?.qualityGroups?.map((qualityG) => ({
          label: qualityG?.value,
          alternativeMatches: [qualityG?.value],
          value: qualityG?.value,
          type: 'string',
        }))
        : '>>';

    const currenciesNames =
      currenciesData.data && currenciesData.data?.currencies
        ? currenciesData.data?.currencies?.map((Curren) => ({
          label: Curren?.shorthand,
          alternativeMatches: [Curren?.value],
          value: Curren?.value,
          type: 'string',
        }))
        : '>>';

    const currenciesAbbrNames =
      currenciesData.data && currenciesData.data?.currencies
        ? currenciesData.data?.currencies?.map((CurrenAbbr) => ({
          label: CurrenAbbr?.value,
          alternativeMatches: [CurrenAbbr?.value],
          value: CurrenAbbr?.value,
          type: 'string',
        }))
        : '>>';

    const shippingLineNames =
      shippingLineData.data && shippingLineData.data?.shippingLines
        ? shippingLineData.data?.shippingLines?.map((ShippingLine) => ({
          label: ShippingLine?.value,
          alternativeMatches: [ShippingLine?.value],
          value: ShippingLine?.value,
          type: 'string',
        }))
        : '>>';

    const quantityUnitNames =
      quantityUnitData.data && quantityUnitData.data?.quantityUnits
        ? quantityUnitData.data?.quantityUnits?.map((quantityUnit) => ({
          label: quantityUnit?.code,
          alternativeMatches: [quantityUnit?.code],
          value: quantityUnit?.code,
          type: 'string',
        }))
        : '>>';

    const preCarriageAreaNames =
      preCarriageAreaData.data && preCarriageAreaData.data?.preCarriageAreas
        ? preCarriageAreaData.data?.preCarriageAreas?.map((carriageArea) => ({
          label: carriageArea?.value,
          alternativeMatches: [carriageArea?.value],
          value: carriageArea?.value,
          type: 'string',
        }))
        : '>>';
    const staticIncoTerms = [
      {
        label: 'CFR',
        alternativeMatches: ['CFR'],
        value: 'CFR',
        type: 'string',
      },
      {
        label: 'CIF',
        alternativeMatches: ['CIF'],
        value: 'CIF',
        type: 'string',
      },
    ];

    // Update portOfLoading names to dropdown state
    setPortLoadingDropdownData(portOfLoadingNames);
    setPortDestinationDropdownData(portOfDestinationNames);
    setPlaceDeliveriesDropdownData(placeOfDeliveryNames);
    setIncoTermDropdownData(staticIncoTerms);
    setQualityGroupDropdownData(qualityGroupNames);
    // setshippingLinesDropdownData(shippingLineNames);
    setCurrenciesDropdownData(currenciesNames);
    setCurrenciesAbbrDropdownData(currenciesAbbrNames);
    setVolumeUnitDropdownData(quantityUnitNames);
    setPreCarriageAreaDropdownData(preCarriageAreaNames);
  };

  function fetchFirstValidityDate(reqLastDt) {
    let retLastDt = '';
    const MAX_ALLOWED_VALUE = 10;
    if (reqLastDt !== '' && reqLastDt) {
      const inputDate = new Date(reqLastDt);
      inputDate.setDate(1);
      const firstDayOfMonth = new Date(inputDate);
      retLastDt = firstDayOfMonth.toISOString().slice(0, MAX_ALLOWED_VALUE);
    }
    return retLastDt;
  }

  const generateValidityDates = (monthNumber) => {
    const currentYear = new Date().getFullYear();
    const selectedMonth = monthNumber - 1;
    // First day of the selected month
    const firstValidityDate = new Date(currentYear, selectedMonth, 1, 5, 30, 0);
    const firstValidityDateString = `${firstValidityDate.getFullYear()}-${(
      firstValidityDate.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}-${firstValidityDate
        .getDate()
        .toString()
        .padStart(2, '0')}`;

    // Last day of the selected month
    const lastDay = new Date(currentYear, selectedMonth + 1, 0);
    const lastValidityDate = new Date(
      lastDay.getFullYear(),
      lastDay.getMonth(),
      lastDay.getDate(),
      5,
      30,
      0
    );
    const lastValidityDateString = `${lastValidityDate.getFullYear()}-${(
      lastValidityDate.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}-${lastValidityDate
        .getDate()
        .toString()
        .padStart(2, '0')}`;

    return {
      firstValidityDate: firstValidityDateString,
      lastValidityDate: lastValidityDateString,
    };
  };

  // Function to detect and extract currency code
  function extractCurrencyCode(cost) {
    // Regular expression to find the numeric part of the cost
    const costRegex = /^([\d.]+)/;

    // Regular expression to find the currency code (e.g., €, USD, GBP, etc.)
    const currencyRegex = /[€$£¥₹Є]|(USD|GBP|CAD|AUD|EUR|INR)/i;

    // Convert the cost to a string before using the regex
    const costString = cost.toString();

    // Use the regex to find the numeric part of the cost
    const costMatch = costString.match(costRegex);
    const numericCost = costMatch ? costMatch[0] : null;

    // Use the regex to find the currency code in the cost string
    const currencyMatch = costString.match(currencyRegex);
    let currencyCode = currencyMatch ? currencyMatch[0] : null;

    // Map currency symbols to their corresponding currency codes
    const currencyMap = {
      '€': 'EUR',
      '$': 'USD',
      '£': 'GBP',
      '¥': 'JPY',
      '₹': 'INR',
      'Є': 'UAH',
    };

    // If the currencyCode is a symbol, map it to the corresponding code
    if (currencyCode && currencyMap[currencyCode]) {
      currencyCode = currencyMap[currencyCode];
    }

    return { cost: numericCost, currency: currencyCode };
  }

  // Function to process the cost column and create the costCurrency column
  function extractCostAndCurrency(costColumn) {
    let retProcessColumn = '';
    const costCurrencyColumn = [];
    if (costColumn !== '' && costColumn) {
      retProcessColumn = extractCurrencyCode(costColumn);
      costCurrencyColumn.push({
        extractedArr: retProcessColumn,
      });
    }
    return costCurrencyColumn;
  }
  // We are using this function for spliting the the rows by '/' for shipping line for ex. CMA/MARESK to two diff rows
  const splitStringBySlash = (inputString) => {
    if (typeof inputString !== 'string') {
      return []; // Handle non-string input
    }

    return inputString.split('/').map((substring) => substring.trim());
  };

  useEffect(() => {
    if (data !== undefined) {
      fetchData();
    }
  }, [data]);

  useEffect(() => {
    refetch1();
  }, [refetch1]);
  useEffect(() => {
    if (!loading1 && data1) {
      const shippingLineNames = data1.filteredProviders.map((logF) => ({
        label: logF.value,
        value: logF.value,
      }));
      setshippingLinesDropdownData(shippingLineNames);
    }
  }, [loading1, data1]);

  // Fetch user unit from URL
  const { id } = useParams();
  const [logisticForwarder, startDate, endDate] = id.split('&');
  let logisticForwarderD = logisticForwarder;
  // Below function we are calling after submission and will push to database
  async function saveAllTransportRates(res) {
    let flg = '';
    if (res !== '' && res.length > 0) {
      const allTransportRatesValue = res.map((freight, index) => {
        return {
          comment: freight.comment === '' ? null : freight.comment,
          freightCost: freight.freightCost === '' ? null : freight.freightCost,
          freightCostCurrency:
            freight.freightCostCurrency === '' ? null : freight.freightCostCurrency,
          freightCostVolume:
            freight.freightCostVolume === '' ? null : freight.freightCostVolume,
          firstValidityDate: freight.startDate,
          incoterm: freight.incoterm === '' ? null : freight.incoterm,
          lastValidityDate: freight.endDate,
          preCarriageLine:
            freight.logisticForwarder === '' ? null : freight.logisticForwarder,
          logisticMaterial:
            freight.logisticMaterial === '' ? null : freight.logisticMaterial,
          portOfDestination:
            freight.portOfDestination === '' ? null : freight.portOfDestination,
          portOfLoading:
            freight.portOfLoading === '' ? null : freight.portOfLoading,
          qualityGroup:
            freight.qualityGroup === '' ? null : freight.qualityGroup,
          shippingLine:
            freight.shippingLine === '' ? null : freight.shippingLine,
          blCost: freight.blCost === '' ? null : freight.blCost,
          blCurrency:
            freight.blCurrency === '' || freight.blCurrency === null
              ? freight.preCarriageCostCurrency
              : freight.blCurrency,
          thcAdminCost:
            freight.thcAdminCost === '' ? null : freight.thcAdminCost,
          thcAdminCostCurrency:
            freight.thcAdminCostCurrency === '' ||
              freight.thcAdminCostCurrency === null
              ? freight.preCarriageCostCurrency
              : freight.thcAdminCostCurrency,
          customsCost: freight.customsCost === '' ? null : freight.customsCost,
          customsCurrency:
            freight.customsCurrency === '' || freight.customsCurrency === null
              ? freight.preCarriageCostCurrency
              : freight.customsCurrency,
          thcAdminCostVolume:
            freight.thcAdminCostVolume === ''
              ? null
              : freight.thcAdminCostVolume,
          volumicCustomsCost:
            freight.volumicCustomsCost === ''
              ? null
              : freight.volumicCustomsCost,
          volumicCustomsCurrency:
            freight.volumicCustomsCurrency === '' ||
              freight.volumicCustomsCurrency === null
              ? freight.preCarriageCostCurrency
              : freight.volumicCustomsCurrency,
          volumicCustomsVolume:
            freight.volumicCustomsVolume === ''
              ? null
              : freight.volumicCustomsVolume,
          preCarriageCost:
            freight.preCarriageCost === '' ? null : freight.preCarriageCost,
          preCarriageCostCurrency:
            freight.preCarriageCostCurrency === '' ||
              freight.preCarriageCostCurrency === null
              ? freight.preCarriageCostCurrency
              : freight.preCarriageCostCurrency,
          preCarriageCostVolume:
            freight.preCarriageCostVolume === ''
              ? null
              : freight.preCarriageCostVolume,
          demurrage: freight.demurrage === '' ? null : freight.demurrage,
          detention: freight.detention === '' ? null : freight.detention,
          preCarriageArea:
            freight.preCarriageArea === '' ? null : freight.preCarriageArea,
        };
      });
    }
    return flg;
  }
  const importerSettings = getTransportAllRateImporterSetting({
    portLoadingDropdownData,
    portDestinationDropdownData,
    incoTermDropdownData,
    qualityGroupDropdownData,
    currenciesDropdownData,
    currenciesAbbrDropdownData,
    shippingLinesDropdownData,
    volumeUnitDropdownData,
    preCarriageAreaDropdownData,
  });
  const handleImportResult = async (result, errors, complete, logs) => {
    if (errors.length === 0) {
      const rest = await saveAllTransportRates(result);
      if (rest.flg) {
        complete();
        setResult(result);
      } else {
        complete(new RejectSubmitResult('Error', rest.message));
        return false;
      }
    } else {
      complete(
        new RejectSubmitResult('Error', 'Please fill the required data.')
      );
      return false;
    }
  };
  const handleDataListing = (modifier, excelData) => {
    // Access the Excel data
    const { data } = _.head(excelData);
    // Transform the data using map and flatMap
    const shippingLineHeaderVariations = [
      'shippingLine',
      'shipping line',
      'shipping Line',
      'Shipping Line',
      'SHIPPING LINE',
    ];
    const shippingLineIndex = data[1].findIndex((header) =>
      shippingLineHeaderVariations.some((variation) =>
        new RegExp(variation, 'i').test(header)
      )
    );
    const sanitizedData = data.flatMap((row, rowIndex) => {
      if (rowIndex === 0) {
        return [row]; // Preserve the header row
      } else {
        // Find the 'shippingLine' column dynamically in each row
        if (shippingLineIndex !== -1) {
          const shippingLine = row[shippingLineIndex];
          const shippingLinesArray = splitStringBySlash(shippingLine);
          return shippingLinesArray.map((line) => {
            const newRow = [...row];
            newRow[shippingLineIndex] = line;
            return newRow;
          });
        } else {
          return [row]; // If 'shippingLine' column is not found, keep the row as-is
        }
      }
    });
    return sanitizedData;
  };

  return (
    <div className='App'>
      <div className='container-wrapper'>
        <div>
          <div className=' FlexCenter'>
            {result !== '' ? (
              <button className=' back-btn' onClick={handleNavigateWeb}>
                {getMessage('Check out freights on web app')}
              </button>
            ) : (
              <NuvoImporter
                licenseKey={licenseKey}
                settings={importerSettings}
                onResults={(result, errors, complete, logs) =>
                  handleImportResult(result, errors, complete, logs)
                }
                onEntryInit={(row, rowIndex) => {
                  // const { firstValidityDate, lastValidityDate } =
                  //   generateValidityDates(validityMonth);
                  const blCurrency = row.blCost;
                  const costVolume = row.costVolume;
                  // const incoterm = incoTerm;
                  const adminCost = row.thcAdminCost;
                  const volumicCutmCost = row.volumicCustomsCost;
                  const preCarrgeCost = row.preCarriageCost;
                  const customsCostAndCurrency = row.customsCost;
                  const portOfLoading = row.portOfLoading;
                  let extractedCurrency = 0;
                  let adminCostCurrency = null;
                  let volumicCustCostCurrency = null;
                  let preCarrageCostCurrency = null;
                  let cost = 0;
                  let extractedAdminCost = 0;
                  let extractedVolumicCustCost = 0;
                  let extractedPreCarrgeCost = 0;
                  let extractedBlCost = 0;
                  let blCostCurrency = null;
                  let customsCost = 0;
                  let customsCurrency = null;
                  let sheetThcAdminCostVolume = row.thcAdminCostVolume;
                  let sheetVolumicCustomsVolume = row.volumicCustomsVolume;
                  let sheetCostVolume = row.freightCostVolume;
                  let sheetPreCarriageCostVolume = row.preCarriageCostVolume;
                  let demurrage = row.demurrage;
                  let detention = row.detention;
                  let preCarriageArea = row.preCarriageArea;
                  let comment = row.comment;
                  // let lane = row.lane;
                  if (row.freightCost) {
                    const [blCostCurrency] =
                      extractCostAndCurrency(row.freightCost) || [];
                    if (blCostCurrency) {
                      cost = blCostCurrency.extractedArr.cost;
                      extractedCurrency = blCostCurrency.extractedArr.currency === '' ? 'USD' :
                        blCostCurrency.extractedArr.currency;
                    }
                  }
                  if (blCurrency) {
                    const [blCostsCurrency] =
                      extractCostAndCurrency(row.blCost) || [];
                    if (blCostsCurrency) {
                      extractedBlCost = blCostsCurrency.extractedArr.cost;
                      blCostCurrency = blCostsCurrency.extractedArr.currency === '' ? 'USD' :
                        blCostsCurrency.extractedArr.currency;
                    }
                  }
                  if (adminCost) {
                    const [adminCostsCurrency] =
                      extractCostAndCurrency(row.thcAdminCost) || [];
                    if (adminCostsCurrency) {
                      extractedAdminCost = adminCostsCurrency.extractedArr.cost;
                      adminCostCurrency =
                        adminCostsCurrency.extractedArr.currency === '' ? 'USD' :
                          adminCostsCurrency.extractedArr.currency;
                    }
                  }
                  if (volumicCutmCost) {
                    const [volumicCostsCurrency] =
                      extractCostAndCurrency(row.volumicCustomsCost) || [];
                    if (volumicCostsCurrency) {
                      extractedVolumicCustCost =
                        volumicCostsCurrency.extractedArr.cost;
                      volumicCustCostCurrency =
                        volumicCostsCurrency.extractedArr.currency === '' ? 'USD' :
                          volumicCostsCurrency.extractedArr.currency;
                    }
                  }
                  if (preCarrgeCost) {
                    const [preCarrgeCurrency] =
                      extractCostAndCurrency(row.preCarriageCost) || [];
                    if (preCarrgeCurrency) {
                      extractedPreCarrgeCost =
                        preCarrgeCurrency.extractedArr.cost;
                      preCarrageCostCurrency =
                        preCarrgeCurrency.extractedArr.currency === '' ? 'USD' :
                          preCarrgeCurrency.extractedArr.currency;
                    }
                  }
                  if (customsCostAndCurrency) {
                    const [customCostsCurrency] =
                      extractCostAndCurrency(row.customsCost) || [];
                    if (customCostsCurrency) {
                      customsCost = customCostsCurrency.extractedArr.cost;
                      customsCurrency =
                        customCostsCurrency.extractedArr.currency === '' ? 'USD' :
                          customCostsCurrency.extractedArr.currency;
                    }
                  }
                  if (row.freightCost) {
                    return {
                      logisticForwarder: {
                        value: logisticForwarderD,
                        info: [
                          {
                            message: 'Logistic forwarder',
                            level: 'info',
                          },
                        ],
                      },
                      logisticMaterial: {
                        value: 'TRAILER',
                        info: [
                          {
                            message: 'Cost to 40HC',
                            level: 'info',
                          },
                        ],
                      },
                      preCarriageArea: {
                        value: preCarriageArea,
                        info: [
                          {
                            message: 'Alcante',
                            level: 'info',
                          },
                        ],
                      },
                      qualityGroup: {
                        value: 'Ferrous',
                        info: [
                          {
                            message: 'Quality group',
                            level: 'info',
                          },
                        ],
                      },
                      firstValidityDate: {
                        value: startDate,
                        info: [
                          {
                            message: 'First validity date',
                            level: 'info',
                          },
                        ],
                      },
                      lastValidityDate: {
                        value: endDate,
                        info: [
                          {
                            message: 'Last validity date',
                            level: 'info',
                          },
                        ],
                      },

                      blCost: {
                        value: extractedBlCost === 0 ? cost : extractedBlCost,
                        info: [
                          {
                            message: 'Bl cost',
                            level: 'info',
                          },
                        ],
                      },
                      blCurrency: {
                        value:
                          blCostCurrency === null
                            ? extractedCurrency
                            : blCostCurrency,
                        info: [
                          {
                            message: 'Bl cost currency',
                            level: 'info',
                          },
                        ],
                      },
                      thcAdminCost: {
                        value:
                          extractedAdminCost === 0 ? cost : extractedAdminCost,
                        info: [
                          {
                            message: 'Admin cost',
                            level: 'info',
                          },
                        ],
                      },
                      thcAdminCostVolume: {
                        value:
                          sheetThcAdminCostVolume === ''
                            ? 'Ctn'
                            : sheetThcAdminCostVolume,
                        info: [
                          {
                            message: 'Admin cost volume',
                            level: 'info',
                          },
                        ],
                      },
                      thcAdminCostCurrency: {
                        value:
                          adminCostCurrency === null
                            ? extractedCurrency
                            : adminCostCurrency,
                        info: [
                          {
                            message: 'Admin cost currency',
                            level: 'info',
                          },
                        ],
                      },
                      customsCost: {
                        value: customsCost === 0 ? cost : customsCost,
                        info: [
                          {
                            message: 'Customs cost',
                            level: 'info',
                          },
                        ],
                      },
                      customsCurrency: {
                        value:
                          customsCurrency === null
                            ? extractedCurrency
                            : customsCurrency,
                        info: [
                          {
                            message: 'Customs cost currency',
                            level: 'info',
                          },
                        ],
                      },
                      incoterm: {
                        value: 'CIF',
                        info: [
                          {
                            message: 'Incoterms',
                            level: 'info',
                          },
                        ],
                      },
                      volumicCustomsCost: {
                        value:
                          extractedVolumicCustCost === 0
                            ? cost
                            : extractedVolumicCustCost,
                        info: [
                          {
                            message: 'Volumic customs cost',
                            level: 'info',
                          },
                        ],
                      },
                      volumicCustomsVolume: {
                        value:
                          sheetVolumicCustomsVolume === ''
                            ? 'Ctn'
                            : sheetVolumicCustomsVolume,
                        info: [
                          {
                            message: 'Volumic customs volume',
                            level: 'info',
                          },
                        ],
                      },
                      volumicCustomsCurrency: {
                        value:
                          volumicCustCostCurrency === null
                            ? extractedCurrency
                            : volumicCustCostCurrency,
                        info: [
                          {
                            message: 'Volumic customs currency',
                            level: 'info',
                          },
                        ],
                      },
                      freightCost: {
                        value:
                          cost === 0 || cost === ''
                            ? null
                            : cost,
                        info: [
                          {
                            message: 'Freight cost',
                            level: 'info',
                          },
                        ],
                      },
                      freightCostVolume: {
                        value:
                          sheetCostVolume === ''
                            ? 'Ctn'
                            : sheetCostVolume,
                        info: [
                          {
                            message: 'Fright cost volume',
                            level: 'info',
                          },
                        ],
                      },
                      freightCostCurrency: {
                        value:
                          extractedCurrency === 0 || extractedCurrency === ''
                            ? null
                            : extractedCurrency,
                        info: [
                          {
                            message: 'Freight currency',
                            level: 'info',
                          },
                        ],
                      },
                      preCarriageCost: {
                        value:
                          extractedPreCarrgeCost === 0
                            ? cost
                            : extractedPreCarrgeCost,
                        info: [
                          {
                            message: 'Pre carriage cost',
                            level: 'info',
                          },
                        ],
                      },
                      preCarriageCostVolume: {
                        value:
                          sheetPreCarriageCostVolume === ''
                            ? 'Ctn'
                            : sheetPreCarriageCostVolume,
                        info: [
                          {
                            message: 'Pre carriage volume',
                            level: 'info',
                          },
                        ],
                      },
                      preCarriageCostCurrency: {
                        value:
                          preCarrageCostCurrency === null
                            ? extractedCurrency
                            : preCarrageCostCurrency,
                        info: [
                          {
                            message: 'Pre carriage currency',
                            level: 'info',
                          },
                        ],
                      },
                      demurrage: {
                        value: demurrage,
                        info: [
                          {
                            message: 'Demurrage in days',
                            level: 'info',
                          },
                        ],
                      },
                      detention: {
                        value: detention,
                        info: [
                          {
                            message: 'Detention in days',
                            level: 'info',
                          },
                        ],
                      },
                      comment: {
                        value: comment,
                        info: [
                          {
                            message: 'comments',
                            level: 'info',
                          },
                        ],
                      },
                    };
                  }
                }}
                dataHandler={{
                  headerStep: (modifier, excelData) =>
                    handleDataListing(modifier, excelData),
                }}
              >
                {getMessage('Import Freight')}
              </NuvoImporter>
            )}
            <button className=' back-btn' onClick={handleGoBack}>
              {getMessage('GO_BACK')}
            </button>
          </div>
          {result !== '' ? (
            <div className='white-box'>
              {Object.keys(result).length !== 0 && (
                <pre>
                  {typeof result === 'string'
                    ? result
                    : JSON.stringify(result, null, 2)}
                </pre>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};
export default TransportAllRateApp;
